<template>
  <div
    :style="{ '--search-input-height': `${height}px` }"
    class="search-input-wrapper"
  >
    <eg-icon
      icon="search"
      class="search-icon"
      size="medium"
      color="var(--color-surface-neutral-container-5)"
    />
    <eg-b-form-input
      v-model="value"
      size="sm"
      :placeholder="placeholder"
      :aria-label="placeholder"
      class="w-100"
      @input="$emit('onChange', value)"
    ></eg-b-form-input>
  </div>
</template>

<script>
export default {
  name: "EgSearch",
  props: {
    placeholder: {
      type: String,
      default: "",
    },

    height: {
      type: [Number, String],
      default: 36,
    },
  },
  data() {
    return {
      value: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.search-input-wrapper {
  position: relative;
  width: 100%;
  max-width: 200px;
  height: 2rem;

  .search-icon {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .form-control {
    height: var(--search-input-height);
    padding-left: 2rem;
    font-size: var(--typography-font-size-fs-300);
    border-color: var(--color-stroke-neutral-default);
    &::placeholder {
      color: var(--color-text-neutral-disabled);
    }
  }

  .clear-input {
    position: absolute;
    bottom: 8px;
    right: 10px;
    cursor: pointer;
  }
}
</style>
